module.exports = __webpack_public_path__ + "static/media/aroseur.bcf7de8.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/aroseur.mp4
// module id = 40
// module chunks = 0